<template>
  <v-navigation-drawer
    v-model="Sidebar_drawer"
    :dark="SidebarColor !== 'white'"
    :color="SidebarColor"
    mobile-breakpoint="960"
    clipped
    :right="$vuetify.rtl"
    mini-variant-width="70"
    :expand-on-hover="expandOnHover"
    app
    id="main-sidebar"
  >
    <v-list dense nav>
      <!---USer Area -->
      <v-list-item two-line class="px-0">
        <v-list-item-avatar>
          <v-img :src="baseURL + imga" />
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>{{ user.username }}</v-list-item-title>
          <v-list-item-subtitle class="caption">{{
            user.type
          }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <!---USer Area -->
      <!---Sidebar Items -->
      <v-flex v-if="user.type == 'Admin'">
        <v-list-item
          v-for="item in admin"
          :key="item.title"
          :to="item.to"
          :class="item.class"
          :active-class="`red white--text`"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-group
          :value="false"
          no-action
          prepend-icon="mdi-account-switch"
          :active-class="`white--text`"
          class="cl"
        >
          <template v-slot:activator>
            <v-list-item-title>Sellers</v-list-item-title>
          </template>
          <v-list-item
            v-for="item in seller"
            :key="item.title"
            :to="item.to"
            :active-class="`red white--text`"
            link
          >
            <!-- <v-list-item-icon>
              <v-icon v-text="icon"></v-icon>
            </v-list-item-icon> -->
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
                <v-list-group
          :value="false"
          no-action
          prepend-icon="mdi-account-switch"
          :active-class="`white--text`"
          class="cl"
        >
          <template v-slot:activator>
            <v-list-item-title>Consultants</v-list-item-title>
          </template>
          <v-list-item
            v-for="item in cons"
            :key="item.title"
            :to="item.to"
            :active-class="`red white--text`"
            link
          >
            <!-- <v-list-item-icon>
              <v-icon v-text="icon"></v-icon>
            </v-list-item-icon> -->
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- <v-list-group
          :value="false"
          no-action
          prepend-icon="mdi-account-cog"
          :active-class="`white--text`"
          class="cl"
        >
          <template v-slot:activator>
            <v-list-item-title>Landing Page</v-list-item-title>
          </template>
          <v-list-item
            v-for="item in landing"
            :key="item.title"
            :to="item.to"
            :active-class="`red white--text`"
            link
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list-group> -->
      </v-flex>
      <v-flex v-if="user.type == 'Admin' || user.type == 'SubAdmin'">
        <v-list-group
          :value="false"
          no-action
          prepend-icon="mdi-gift"
          :active-class="`white--text`"
          class="cl"
        >
          <template v-slot:activator>
            <v-list-item-title>Products</v-list-item-title>
          </template>
          <v-list-item
            v-for="item in products"
            :key="item.title"
            :to="item.to"
            :active-class="`red white--text`"
            link
          >
            <!-- <v-list-item-icon>
              <v-icon v-text="icon"></v-icon>
            </v-list-item-icon> -->
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-item
          v-for="item in common"
          :key="item.title"
          :to="item.to"
          :class="item.class"
          :active-class="`red white--text`"
          link
        >
          <v-list-item-icon>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-flex>
      <!---Sidebar Items -->

      <!-- <v-list-group
        :value="false"
        no-action
        prepend-icon="mdi-home"
        :active-class="`white--text`"
      >
        <template v-slot:activator>
          <v-list-item-title>Home Display</v-list-item-title>
        </template>
        <v-list-item
          v-for="item in admins"
          :key="item.title"
          :to="item.to"
          :active-class="`red white--text`"
          link
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list-group>
      <v-list-group
        :value="false"
        no-action
        prepend-icon="mdi-information"
        :active-class="`white--text`"
      >
        <template v-slot:activator>
          <v-list-item-title>Static</v-list-item-title>
        </template>
        <v-list-item
          to="/Footer/footerHeading"
          :active-class="`red white--text`"
          link
        >
          <v-list-item-title>Footer Heading</v-list-item-title>
        </v-list-item>
       
        <v-list-item
          to="/staticFooter/Refer A Friend"
          :active-class="`red white--text`"
          link
        >
        </v-list-item>
        <v-list-item to="/newBlog" :active-class="`red white--text`" link>
        </v-list-item>
        <v-list-item
          to="/staticFooter/FAQ"
          :active-class="`red white--text`"
          link
        >
        </v-list-item>
        <v-list-item
          to="/staticFooter/Careers"
          :active-class="`red white--text`"
          link
        >
        </v-list-item>
        <v-list-item
          to="/staticFooter/Exchange & Return"
          :active-class="`red white--text`"
          link
        >
        </v-list-item>
        <v-list-item
          to="/staticFooter/Sell on Styloop"
          :active-class="`red white--text`"
          link
        >
        </v-list-item>
        <v-list-item
          to="/staticFooter/Collaborate with us"
          :active-class="`red white--text`"
          link
        >
        </v-list-item>
        <v-list-item
          to="/staticFooter/Invest With US"
          :active-class="`red white--text`"
          link
        >
        </v-list-item>
        <v-list-item
          to="/staticComponent/Marquee"
          :active-class="`red white--text`"
          link
        >
          <v-list-item-title>Marquee</v-list-item-title>
        </v-list-item>
        <v-list-item
          to="/staticComponent/Styloop"
          :active-class="`red white--text`"
          link
        >
          <v-list-item-title>Woopgo</v-list-item-title>
        </v-list-item>
        <v-list-item
          to="/staticComponent/Styloop Description"
          :active-class="`red white--text`"
          link
        >
          <v-list-item-title>Woopgo Description</v-list-item-title>
        </v-list-item>
        <v-list-item
          to="/staticComponent/Company"
          :active-class="`red white--text`"
          link
        >
          <v-list-item-title>Company</v-list-item-title>
        </v-list-item>
      </v-list-group> -->
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import store from "../../store";
import { mapState } from "vuex";
import axios from "axios";
export default {
  name: "Sidebar",
  props: {
    expandOnHover: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    user: [],
    title: [],
    landing: [
      {
        title: "Landing Page",
        to: "/LandingPage/landingPage",
        class: "",
      },
      {
        title: "Landing Page Queries",
        to: "/LandingPage/queries",
        class: "",
      },
    ],
    seller: [
      {
        title: "Sellers",
        // icon: "mdi-account-group",
        to: "/sellers/seller",
      },
      {
        title: "Pending Sellers",
        to: "/pendingSellers",
      },
      {
        title: "Removed Sellers",
        to: "/removeSellers",
      },
      {
        title: "Pincodes",
        to: "/pincodes",
      },
    ],
      cons: [
      {
        title: "Consultants",
        // icon: "mdi-account-group",
        to: "/consultants",
      },
      {
        title: "Pending Consultants",
        to: "/pendingConsultants",
      },
      {
        title: "Removed Consultants",
        to: "/removeConsultants",
      },
    ],
    products: [
      {
        title: "Active Products",
        icon: "mdi-gift",
        to: "/Products/productView",
      },
      {
        title: "Pending Products",
        icon: "mdi-dropbox",
        to: "/pendingProducts",
      },
      // {
      //   title: "Offer Products",
      //   icon: "mdi-offer",
      //   to: "/offer",
      // },
      // {
      //   title: "Product Tags",
      //   icon: "mdi-dropbox",
      //   to: "/ProductTags",
      // },
    ],
    admins: [
      { title: "Slider", to: "/home/sliderList" },
      { title: "Trending Slider", to: "/home/trendingSlider" },
      { title: "Exclusive", to: "/home/exclusiveList" },
      { title: "Trending", to: "/home/trendingList" },
      { title: "Discount Vouchers", to: "/home/blog" },
      { title: "House of Beauty", to: "/home/houseofBeauty" },
      {
        title: "Main Collection",
        to: "/home/mainCollection",
      },
      { title: "Collection", to: "/home/collectionList" },
      { title: "Login Background", to: "/home/loginBackground" },
      { title: "Feedback Content", to: "/home/lookingFor" },
    ],
    stat: [
      {
        title: "Marquee",
        to: "/staticComponent/Marquee",
      },
      {
        title: "Footer Heading",
        to: "/staticComponent/Footer Heading",
      },
      {
        title: "Styloop Description",
        to: "/staticComponent/Styloop Description",
      },
      {
        title: "Company",
        to: "/staticComponent/Company",
      },
    ],

    admin: [
      {
        title: "Dashboard",
        icon: "mdi-view-dashboard",
        to: "/dashboard/basic-dashboard",
      },
      // {
      //   title: "Add Reviews",
      //   icon: "mdi-star-plus",
      //   to: "/rating/ratingList",
      // },
      // {
      //   title: "User Reviews",
      //   icon: "mdi-star",
      //   to: "/UserReview/userReview",
      // },
      // {
      //   title: "Subscribers List",
      //   icon: "mdi-youtube-subscription",
      //   to: "/Subscribe/subscribe",
      // },
      // {
      //   title: "Guest Feedback",
      //   icon: "mdi-monitor-eye",
      //   to: "/Guest/lookingFor",
      // },
      // {
      //   title: "Business Query",
      //   icon: "mdi-account-cog",
      //   to: "/Business/businessQuery",
      //   class: "",
      // },
      //   {
      //   title: "Landing Page Queries",
      //   icon: "mdi-account-cog",
      //   to: "/LandingPage/queries",
      //   class: "",
      // },
      //  {
      //   title: "Dynamic Image Links",
      //   icon: "mdi-account-cog",
      //   to: "/dynamicLinks",
      //   class: "",
      // },
      {
        title: "Users",
        icon: "mdi-account-group",
        to: "/users/user",
        class: "space",
      },
      {
        title: "Admins",
        icon: "mdi-account-supervisor",
        to: "/admins/admin",
        // class:'cl',
      },
    ],
    common: [
      // {
      //   title: "Size Chart",
      //   icon: "mdi-view-list",
      //   to: "/sizeChart",
      // },

      // {
      //   title: "Pending Offers",
      //   icon: "mdi-offer",
      //   to: "/pendingOffer",
      // },
      // {
      //   title: "Pending Deals",
      //   icon: "mdi-share-circle",
      //   to: "/Deal/deal",
      // },
      // {
      //   title: "Approved Deals",
      //   icon: "mdi-handshake",
      //   to: "/Deal/approvedDeals",
      // },
      // {
      //   title: "Purchase",
      //   icon: "mdi-cart",
      //   to: "/purchases/purchaseList",
      // },
      // {
      //   title: "Payment Reports",
      //   icon: "mdi-cart",
      //   to: "/paymentReport",
      // },
      // {
      //   title: "Promo Codes",
      //   icon: "mdi-barcode",
      //   to: "/promoCode",
      // },
      // {
      //   title: "Footer Heading",
      //   icon: "mdi-page-layout-header-footer",
      //   to: "/Footer/footerHeading",
      // },
      {
        title: "Category",
        icon: "mdi-view-list",
        to: "/category/categories",
        class: "space",
      },
      // {
      //   title: "Styl-Category",
      //   icon: "mdi-format-list-text",
      //   to: "/stylCategory/stylCategories",
      // },
      {
        title: "Sub-category",
        icon: "mdi-format-list-bulleted-square",
        to: "/subCategory",
      },
      // {
      //   title: "Blog-Category",
      //   icon: "mdi-format-list-text",
      //   to: "/blogCategories",
      // },
    ],
    // subadmin: [
    //   {
    //     title: "Products",
    //     icon: "mdi-gift",
    //     to: "/Products/productView",
    //   },
    //   {
    //     title: "Pending Product",
    //     icon: "mdi-dropbox",
    //     to: "/pendingProducts",
    //   },
    //   {
    //     title: "Pending Offer",
    //     icon: "mdi-offer",
    //     to: "/pendingOffer/offer",
    //   },
    //   {
    //     title: "Pending Deals",
    //     icon: "mdi-share-circle",
    //     to: "/Deal/deal",
    //   },
    //   {
    //     title: "Approved Deals",
    //     icon: "mdi-handshake",
    //     to: "/Deal/approvedDeals",
    //   },
    //   {
    //     title: "Purchase",
    //     icon: "mdi-cart",
    //     to: "/purchases/purchaseList",
    //   },
    //   // {
    //   //   title: "Footer Heading",
    //   //   icon: "mdi-page-layout-header-footer",
    //   //   to: "/Footer/footerHeading",
    //   // },
    //   {
    //     title: "Category",
    //     icon: "mdi-view-list",
    //     to: "/category/categories",
    //     class: "space",
    //   },
    //   {
    //     title: "Styl-Category",
    //     icon: "mdi-format-list-text",
    //     to: "/stylCategory/stylCategories",
    //   },
    //   {
    //     title: "Sub-category",
    //     icon: "mdi-format-list-bulleted-square",
    //     to: "/subCategory",
    //     // class:"cl"
    //   },
    // ],
  }),
  computed: {
    imga() {
      return store.state.profilePic;
    },
    ...mapState(["SidebarColor", "SidebarBg"]),
    Sidebar_drawer: {
      get() {
        return this.$store.state.Sidebar_drawer;
      },
      set(val) {
        this.$store.commit("SET_SIDEBAR_DRAWER", val);
      },
    },
  },
  watch: {
    "$vuetify.breakpoint.smAndDown"(val) {
      this.$emit("update:expandOnHover", !val);
    },
  },
  beforeMount() {
    this.getData();
    this.getList();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/user/profile",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.user = response.data.data;
            // this.userStatus = this.user.status;
            console.log(this.user);
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    getList() {
      this.appLoading = true;
      axios({
        url: "/home/getfootertext",
        method: "GET",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          count: this.count,
          page: this.currentPage,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.title = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss">
#main-sidebar {
  box-shadow: 1px 0 20px rgba(0, 0, 0, 0.08);
  -webkit-box-shadow: 1px 0 20px rgba(0, 0, 0, 0.08);
  .v-navigation-drawer__border {
    display: none;
  }
  .v-list {
    padding: 8px 15px;
  }
  .v-list-item {
    &__icon--text,
    &__icon:first-child {
      justify-content: center;
      text-align: center;
      width: 20px;
    }
  }
}
.cl {
  padding-bottom: 15px !important;
}
.space {
  padding-top: 15px !important;
}
</style>